import { Button } from "@mui/material";
import { useState } from "react";
import CatalogAccessDialog from "./CatalogAccessDialog";
import { User } from "../../app/backendTypes";

export default function CatalogAccessButton(props: {
  user: User;
  catalogId: string;
  catalogName: string;
  callback: () => void;
}) {
  const { user, catalogId, catalogName, callback } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        color="secondary"
        onClick={() => setOpen(true)}
        variant="outlined"
      >
        Request Access
      </Button>

      {user !== null && (
        <CatalogAccessDialog
          onboarded={false}
          open={open}
          setOpen={setOpen}
          catalogName={catalogName}
          catalogId={catalogId}
          user={user}
          callback={callback}
        />
      )}
    </>
  );
}
